import { useEffect, useState } from 'react';

export const useFilePermissions = (file: any, groups: Array<any>) => {
  const [groupColours, setGroupColours] = useState<Array<any>>([]);
  const [visibility, setVisibility] = useState<Array<number>>([0, 1]);

  useEffect(() => {
    const visArray = JSON.parse(file.access_level);
    setVisibility(visArray);
    setGroupColours([]);

    if (!Array.isArray(groups)) {
      console.error('groups is not an array');
      return;
    }

    for (const groupID of visArray) {
      const group = groups.find((group) => group.ID === groupID);
      if (group) {
        setGroupColours((prev) => [...prev, group]);
      }
    }
    // Preserve the original mount-only grouping behavior for this item.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    groupColours,
    visibility,
  };
};
